import { render, staticRenderFns } from "./videoDetail.vue?vue&type=template&id=bad45a7c&scoped=true&"
import script from "./videoDetail.vue?vue&type=script&lang=js&"
export * from "./videoDetail.vue?vue&type=script&lang=js&"
import style0 from "./videoDetail.vue?vue&type=style&index=0&id=bad45a7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad45a7c",
  null
  
)

export default component.exports